import Vue from "vue";
import Mint from "mint-ui";
Vue.use(Mint);
import moment from "moment";
import KProgress from "k-progress";
import httpService from "./utils/service";
import "normalize.css";
import "./assets/less/common.less";
import "./assets/less/animate.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueTypedJs from "./components/VueTypedJs/index.js";
// import VConsole from "vconsole";

import "./utils/rem";

Vue.component("k-progress", KProgress);

Vue.directive("focus", {
  inserted: function (el) {
    el.focus();
  },
});
Vue.mixin({
  data() {
    return {
      service: "",
      router: "",
      imgSrc: "",
    };
  },
  created() {
    if (window) {
      this.service = httpService;
    }
  },
});
Vue.config.productionTip = false;
Vue.prototype.$moment = moment;

if (process.env.NODE_ENV == "development") {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}
Vue.use(Mint);
Vue.use(VueTypedJs);
// CI/CD不支持VueTypedJs中引入typejs的方法, 改为本地组件
// const vConsole = new VConsole();
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
